export const entity_language = {
    entity: {
        activity: "Attività sales",
        area_geografica: "Geografia (Statistiche)",
        auth_pin: "PIN di autenticazione",
        auth_token: "Token di autenticazione",
        attributes: "Attributi",
        bank: "Banche",
        brand: "Brand",
        catalog: "Catalogo",
        contatore: "Contatori",
        country: "Nazioni",
        customer: "Clienti",
        customer_contacts: "Contatti cliente",
        customer_ddt: "Documenti di trasporto (DDT)",
        customer_ddt_rows: "Righe DDT cliente",
        customer_invoices: "Fatture",
        customer_invoices_rows: "Righe fattura cliente",
        customer_offer: "Preventivi clienti",
        customer_offer_rows: "Righe preventivo cliente",
        customer_offices: "Sede cliente",
        customer_order: "Ordini cliente",
        customer_order_rows: "Righe ordine cliente",
        customer_sales_agent: "Agenti cliente",
        customer_transport_document: "Documenti spedizione",
        customer_transport_document_rows: "Righe documento trasporto",
        ddt_supplier_rows: "Righe DDT fornitore",
        designer: "Designer",
        formulario: "Formulario",
        forwarder: "Spedizionieri",
        glossario: "Glossario",
        gyt_order_list_request: "Storico elaborazioni",
        gyv_all_supplier_item: "Listino fornitori",
        gyv_close_customer_rows: "Righe chiuse ordini cliente",
        gyv_customer_transport_document: "Documenti spedizione",
        gyv_customer_transport_document_rows: "Righe documento trasporto (vista)",
        gyv_item_model_cor: "Articoli (vista)",
        gyv_mpm: "Distinta base",
        gyv_mrp_order_list: "Lista bisogni completa",
        gyv_open_customer_rows: "Area produzione",
        gyv_pdc: "Area Preparazione PDC",
        gyv_stocks: "Giacenze",
        gyv_supplier_order_rows_open: "Area produzione fornitore",
        incoterms: "Incoterms",
        intestazioni: "Intestazioni",
        item_model: "Articoli",
        item_model_catalog: "Cataloghi",
        item_model_family: "Raggruppamenti",
        item_model_files: "Allegati articoli",
        item_model_movement: "Movimentazioni",
        item_model_photo_gallery: "Galleria foto articoli",
        item_model_quantity: "Quantità articoli a magazzino",
        item_model_suppliers: "Listino fornitori",
        languages: "Lingue",
        listino: "Listini",
        log: "Log di sistema",
        manufacturing_process_model: "Distinta base",
        measure_unit: "Unità di misura",
        movement_scope: "Causali movimentazione",
        mp_children: "Figli distinta base",
        payment_condition: "Condizioni di pagamento",
        payment_condition_group: "Gruppi condizioni di pagamento",
        person_role: "Ruoli",
        prescrittore: "Prescrittori",
        resource: "Risorse",
        sales_agent: "Agenti",
        sales_agent_cataloghi: "Cataloghi Agenti",
        sales_agent_contacts: "Contatti agente",
        shipping_plan: "Piano di carico",
        shipping_plan_rows: "Righe piano di carico",
        shipping_plan_voyages: "Viaggi piano di carico",
        shipping_rates: "Tariffe di spedizione",
        statement_intent: "Plafond Iva",
        supplier: "Fornitori",
        supplier_contacts: "Contatti fornitore",
        supplier_offices: "Sede fornitore",
        supplier_order: "Ordini fornitore",
        supplier_order_rows: "Righe ordine fornitore",
        supplier_transport_document: "DDT fornitori",
        supplier_transport_document_rows: "Righe DDT fornitore",
        template: "Template stampe",
        template_mail: "Template mail",
        transport_document_reason: "Causali DDT",
        user: "Utenti",
        user_entity_preferences: "Preferenze entità",
        user_entity_saved_filters: "Filtri salvati",
        user_group: "Gruppi",
        vat_condition: "Condizioni IVA",
        warehouse: "Magazzini",
        company_settings: "Impostazioni azienda",
        supplier_invoices_received: "Fatture passive ricevute"
    },
    labels: {
        "activity": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "idCustomer": 'Cliente',
            "notes": 'Note',
            "type": 'Tipo contatto',
            "type.options.0_PHONE": 'Telefono',
            "type.options.10_EMAIL": 'Email',
            "type.options.20_MEET": 'Incontro',
            "nextDate": 'Data prossimo contatto'
        },
        "area_geografica": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "idSalesAgent": 'Agente',
            "regioneProvincia": 'Regione-Provincia',
            "notes": 'Note'
        },
        "auth_pin": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUser": 'Utente',
            "pin": 'PIN'
        },
        "auth_token": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUser": 'Utente',
            "sid": 'Session ID',
            "ltsid": 'Long Term Session ID'
        },
        "bank": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "abi": 'ABI',
            "cab": 'CAB',
            "description": 'Descrizione',
            "isACompanyBank": 'isACompanyBank',
            "counter": 'Sede',
            "address": 'Indirizzo',
            "cap": 'CAP',
            "city": 'Città',
            "notes": 'Note',
            "disabled": 'Disabilitato'
        },
        "brand": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione'
        },
        "catalog": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione'
        },
        "contatore": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "entity": 'Entità (non modificare)',
            "name": 'Nome',
            "count": 'Count',
            "notes": 'Note'
        },
        "country": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "codiceGestionaleEsterno": 'Codice gestionale esterno',
            "idVatCondition": 'Condizione IVA',
            "codiceISO": 'Codice ISO',
            "idLanguages": 'Lingua',
            "idIncoterms": 'Incoterms',
            "italiaEstero": 'Italia Estero',
            "isUE": 'UE',
            "certificatoOrigine": 'Certificato origine',
            "codiciDoganaliInFatt": 'Codici doganali in fattura',
            "areaGeoObbligatorio": 'Geografia (Statistiche) obbligatoria',
            "notes": 'Note'
        },
        "customer": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione Sociale',
            "category": 'Tipo cliente fiscale',
            "category.options.0": 'Privato',
            "category.options.1": 'Società di capitali',
            "category.options.2": 'Società di persone',
            "address": 'Indirizzo',
            "idCountry": 'Nazione',
            "italiaEstero": 'Italia - Estero',
            "certificatoOrigine": 'Certificato d\'origine',
            "certificatoOrigine.options.0": 'No',
            "certificatoOrigine.options.1": 'Si',
            "codiciDoganaliInFatt": 'Codici doganali in fattura',
            "codiciDoganaliInFatt.options.0": 'No',
            "codiciDoganaliInFatt.options.1": 'Si',
            "region": 'Regione',
            "province": 'Provincia',
            "country": 'Stato',
            "city": 'Città',
            "cap": 'CAP',
            "countryCode": 'Codice ISO',
            "orderEmail": 'Email ordini',
            "billingEmail": 'Email fatturazione',
            "website": 'Sito web',
            "phone": 'Telefono',
            "stateVatNumber": 'Stato P.iva',
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "notesOrder": 'Note ordine',
            "notesInvoice": 'Note fattura',
            "notesInternal": 'Note interne',
            "idPaymentCondition": 'Condizione di pagamento',
            "idVatCondition": 'Condizione iva',
            "contacts": 'Contatti',
            "offices": 'Indirizzi di consegna',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "discount4": 'Sconto 4 [%]',
            "discount5": 'Sconto expo [%]',
            "language": 'Lingua',
            "language.options.0_ITA": 'Italiano',
            "language.options.1_ENG": 'Inglese',
            "language.options.2_DE": 'Tedesco',
            "language.options.3_SPA": 'Spagnolo',
            "pec": 'PEC',
            "iban": 'IBAN',
            "idIncoterms": 'Incoterms',
            "idSpedizione": 'Tariffa di spedizione',
            "documentType": 'Tipo documento preferenziale',
            "documentType.options.DDT": 'DDT',
            "documentType.options.INVOICE": 'Fattura accompagnatoria',
            "codiceVecchioGestionale": 'Codice vecchio gestionale',
            "visible": 'Attivo',
            "isBlocked": 'Bloccato',
            "idSalesAgent": 'Agente',
            "sdi": 'Codice SDI',
            "namePrivate": 'Nome',
            "surnamePrivate": 'Cognome',
            "codiceGestionaleEsterno": 'Codice gestionale esterno',
            "idListino": 'Listino di riferimento',
            "aggregateInvoices": 'Aggrega i documenti',
        },
        "customer_contacts": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomer": 'Cliente',
            "name": 'Nome',
            "surname": 'Cognome',
            "idRole": 'Ruolo',
            "roleDescription": 'Descrizione ruolo',
            "sendOrder": 'CC ordini/preventivi',
            "sendInvoice": 'CC fatture',
            "sendDdt": 'CC ddt',
            "mobile": 'Cellulare',
            "email": 'Email',
            "notes": 'Note'
        },
        "customer_ddt": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "notes": 'Note',
            "idCustomer": 'Cliente',
            "rows": 'Articoli',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CONFIRMED": 'Fatturato',
            "status.options.20_UNLOADED": 'Scaricato',
            "internalCode": 'Codice interno',
            "idCustomerOffice": 'Sede',
            "externalCode": 'Riferimento cliente',
            "packagesQuantity": 'Numero colli',
            "weight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "nameCustomer": 'Nome cliente',
            "addressCustomer": 'Indirizzo cliente',
            "phoneCustomer": 'Telefono cliente',
            "vatNumberCustomer": 'Partita Iva cliente',
            "incotermsCustomer": 'Incoterms cliente',
            "addressCustomerOffice": 'Indirizzo sede',
            "phoneCustomerOffice": 'Telefono sede',
            "transportReason": 'Causale del trasporto',
            "nameForwarder": 'Nome Spedizioniere',
            "paymentConditionCustomer": 'Condizioni di pagamento',
            "orderNumber": 'Numero ordine',
            "bankCustomer": 'Banca cliente',
            "abi": 'ABI',
            "cab": 'CAB',
            "iban": 'IBAN',
            "dateSendDocument": 'Data invio documento'
        },
        "customer_ddt_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "codeItemModel": 'Codice articolo',
            "nameItemModel": 'Descrizione articolo',
            "unitItemModel": 'Unità di misura',
            "quantity": 'Quantità',
            "quantityUnloaded": 'Quantità scaricata',
            "priceItemModel": 'Prezzo',
            "discountItemModel": 'Sconto',
            "notes": 'Note',
            "packages": 'Colli',
            "idItemModel": 'ID articolo',
            "riferimentoCustomerOrder": 'Riferimento ordine',
            "warehouseItemModel": 'Magazzino',
            "fulfilledQuantity": 'Quantità evasa',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_UNLOADED": 'Scaricato',
            "idCustomerDDT": 'DDT cliente',
            "idCustomerOrder": 'Ordine cliente',
            "idCustomerOrderRow": 'Riga ordine cliente'
        },
        "customer_invoices": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "notes": 'Note',
            "documentType": 'Tipo fattura',
            "documentType.options.0": 'Fattura accompagnatoria',
            "documentType.options.1": 'Fattura differita',
            "idCustomer": 'Cliente',
            "rows": 'Articoli',
            "internalCode": 'Numero fattura',
            "idCustomerOffice": 'Sede',
            "externalCode": 'Riferimento cliente',
            "packagesQuantity": 'Numero colli',
            "weight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "nameCustomer": 'Nome cliente',
            "addressCustomer": 'Indirizzo cliente',
            "phoneCustomer": 'Telefono cliente',
            "vatNumberCustomer": 'Partita Iva cliente',
            "incotermsCustomer": 'Incoterms cliente',
            "addressCustomerOffice": 'Indirizzo sede',
            "phoneCustomerOffice": 'Telefono sede',
            "transportReason": 'Causale del trasporto',
            "paymentConditionCustomer": 'Condizioni di pagamento',
            "bankCustomer": 'Banca cliente',
            "nameForwarder": 'Nome Vettore',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CONFIRMED": 'Fatturato',
            "status.options.20_UNLOADED": 'Scaricato',
            "totalPrice": 'Totale IVA inclusa',
            "totalIva": 'Totale IVA',
            "costSpedizione": 'Imponibile spedizione',
            "idIvaSped": 'IVA spedizione',
            "idIvaOrdine": 'IVA ordine',
            "costIncasso": 'Imponibile incasso',
            "abbuono": 'Abbuono',
            "totalImballo": 'Totale imballo',
            "totalImponibile": 'Totale imponibile',
            "idPaymentCondition": 'ID Condizione di pagamento',
            "idAgent": 'ID Agente',
            "abi": 'ABI',
            "cab": 'CAB',
            "iban": 'IBAN',
            "orderNumber": 'Numero ordine',
            "tablePayments": 'Scadenza pagamenti',
            "installmentsPayments": 'Rate pagamenti',
            "typePayments": 'Tipo pagamenti',
            "totalPayments": 'Totale pagamenti',
            "dateSendDocument": 'Data invio documento',
            "sdiStatus": 'Stato SDI',
            "sdiStatus.options.da_inviare": 'Da inviare',
            "sdiStatus.options.inviata": 'Inviata',
            "sdiStatus.options.consegnata": 'Consegnata',
            "sdiStatus.options.rifiutata": 'Rifiutata',
            "sdiStatus.options.errore": 'Errore',
            "sdiStatus.options.non_consegnata": 'Non consegnata',
            "sdiFilename": 'Nome file SDI',
            "sdiIdSdi": 'Identificativo SDI',
            "sdiDate": 'Data invio SDI',
            "sdiError": 'Errore SDI',
            "tipoDocumento": 'Tipo documento FE',
            "tipoDocumento.options.TD01": 'TD01 - Fattura',
            "tipoDocumento.options.TD02": 'TD02 - Acconto',
            "tipoDocumento.options.TD04": 'TD04 - Nota credito',
            "tipoDocumento.options.TD24": 'TD24 - Differita',
            "tipoDocumento.options.TD25": 'TD25 - Differita art.36',
            "modalitaPagamento": 'Modalità pagamento FE',
            "modalitaPagamento.options.MP01": 'MP01 - Contanti',
            "modalitaPagamento.options.MP02": 'MP02 - Assegno',
            "modalitaPagamento.options.MP05": 'MP05 - Bonifico',
            "modalitaPagamento.options.MP08": 'MP08 - Carta',
            "modalitaPagamento.options.MP12": 'MP12 - RIBA'
        },
        "customer_invoices_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "codeItemModel": 'Codice articolo',
            "nameItemModel": 'Dascrizione articolo',
            "unitItemModel": 'Unità di misura',
            "quantity": 'Quantità',
            "fulfilledQuantity": 'Quantità evasa',
            "quantityUnloaded": 'Quantità scaricata',
            "priceItemModel": 'Prezzo',
            "discountItemModel": 'Sconto',
            "notes": 'Note',
            "packages": 'Colli',
            "idItemModel": 'ID articolo',
            "idIvaItemModel": 'ID IVa articolo',
            "ivaItemModel": 'Iva',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_UNLOADED": 'Scaricato',
            "totalRow": 'Totale imponibile riga',
            "totalIva": 'Totale IVA riga',
            "total": 'Totale riga',
            "idCustomerInvoices": 'Fattura cliente',
            "idCustomerOrder": 'Ordine cliente',
            "idCustomerOrderRow": 'Riga ordine cliente',
            "riferimentoDDT": 'Riferimento DDT',
            "itemMerce": 'Articolo merce',
            "contropartita": 'Contropartita',
            "idDichIntento": 'Dichiarazione di intento',
            "udm": 'Unità di misura'
        },
        "customer_offer": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomer": 'Cliente',
            "idAreaGeografica": 'Geografia (Statistiche)',
            "idSalesAgent": 'Agente',
            "idCountryStats": 'Nazione (Statistiche)',
            "idPrescrittore": 'Prescrittore',
            "internalCode": 'Numero preventivo',
            "externalCode": 'Riferimento cliente',
            "offerDate": 'Data preventivo',
            "deliveryDate": 'Data prevista pronto merce',
            "notesOffer": 'Note ordine',
            "notesInvoice": 'Note fattura',
            "notesInternal": 'Note interne',
            "idIncoterms": 'Incoterms',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "discount4": 'Sconto 4 [%]',
            "discount5": 'Sconto expo [%]',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_PARTIALLY_COMPLETED": 'Parzialmente evaso',
            "status.options.20_COMPLETED": 'Evaso',
            "rows": 'Righe preventivo',
            "documentType": 'Tipo documento preferenziale',
            "documentType.options.DDT": 'DDT solo stampa',
            "documentType.options.INVOICE": 'Fattura accompagnatoria',
            "idPaymentCondition": 'Condizione di pagamento',
            "idVatCondition": 'Condizione IVA',
            "idLanguages": 'Lingua',
            "italiaEstero": 'Italia - Estero',
            "certificatoOrigine": 'Certificato d\'origine',
            "codiciDoganaliInFatt": 'Codici doganali in fattura',
            "address": 'Indirizzo di consegna',
            "idSpedizione": 'Tariffe di spedizione',
            "costSpedizione": 'Imponibile spedizione',
            "costImballo": 'Imponibile imballo',
            "costIncasso": 'Imponibile incasso Ri.Ba',
            "totalSpedizione": 'Totale spedizione IVA inclusa',
            "totalImballo": 'Totale imballo IVA inclusa',
            "totalIncasso": 'Totale imponibile incasso Ri.Ba',
            "totalIncassoIva": 'Totale incasso Ri.Ba IVA inclusa',
            "totalImponibile": 'Totale imponibile preventivo',
            "totalIva": 'Totale IVA preventivo',
            "totalPrice": 'Totale preventivo',
            "provvigioneAgente": 'Provvigione agente',
            "provvigionePrescrittore": 'Provvigione prescrittore',
            "idListino": 'Listino di riferimento',
            "idWarehouseOutlet": 'Magazzino',
            "dateSendDocument": 'Data invio documento',
            "fileDocument": 'Documento allegato',
            "numberDocument": 'Numero documento'
        },
        "customer_offer_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Codice articolo',
            "name": 'Descrizione articolo',
            "measureUnit": 'Unità di misura',
            "quantity": 'Quantità',
            "fulfilledQuantity": 'Quantità evasa',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "discount4": 'Sconto 4 [%]',
            "discount5": 'Sconto expo [%]',
            "price": 'Prezzo unitario [€]',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_PARTIALLY_COMPLETED": 'Parzialmente evasa',
            "status.options.20_COMPLETED": 'Evaso',
            "internalNotes": 'Note interne',
            "percentualeAgente": 'Percentuale agente',
            "percentualePrescrittore": 'Percentuale prescrittore',
            "packages": 'Colli',
            "packaging": 'Cassa di legno',
            "deliveryTime": 'Settimane di consegna',
            "deliveryDate": 'Data prevista pronto merce',
            "volume": 'Volume imballo (mc)',
            "length": 'Lunghezza imballo (cm)',
            "height": 'Altezza imballo (cm)',
            "depth": 'Profondità imballo (cm)',
            "grossWeight": 'Peso lordo (kg)',
            "netWeight": 'Peso netto (kg)',
            "customsCode": 'Codice doganale',
            "idVatCondition": 'Condizione IVA',
            "totalRow": 'Totale imponibile riga',
            "totalIva": 'Totale IVA riga',
            "total": 'Totale riga',
            "idCustomerOffer": 'Preventivo cliente',
            "idShippingPlan": 'ID Piano di carico',
            "pdc": 'Area PDC'
        },
        "customer_offices": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "type.options.0_SHOP": 'Negozio',
            "type.options.1_SHOWROOM": 'Showroom',
            "name": 'Nome sede',
            "phone": 'Telefono',
            "email": 'Email',
            "address": 'Indirizzo',
            "idCountry": 'Nazione',
            "city": 'Città',
            "cap": 'CAP',
            "internalNotes": 'Note interne',
            "idCustomer": 'Cliente',
            "isDeliveryDefault": 'Default consegna'
        },
        "customer_order": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomer": 'Cliente',
            "idAreaGeografica": 'Geografia (Statistiche)',
            "idSalesAgent": 'Agente',
            "idCountryStats": 'Nazione (Statistiche)',
            "idPrescrittore": 'Prescrittore',
            "internalCode": 'Numero ordine',
            "orderCustomer": 'Ordine cliente',
            "externalCode": 'Riferimento cliente',
            "substitutionMotivation": 'Motivazione sostituzione',
            "orderDate": 'Data ordine',
            "deliveryDate": 'Data prevista pronto merce',
            "notesOrder": 'Note ordine',
            "notesInvoice": 'Note fattura',
            "notesInternal": 'Note interne',
            "idIncoterms": 'Incoterms',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "discount4": 'Sconto 4 [%]',
            "discount5": 'Sconto expo [%]',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_CONFIRMED": 'Confermato',
            "status.options.20_PARTIALLY_COMPLETED": 'Parzialmente evaso',
            "status.options.30_COMPLETED": 'Evaso',
            "status.options.40_PAID": 'Pagato',
            "status.options.50_CANCELED": 'Pagato',
            "rows": 'Righe ordine',
            "documentType": 'Tipo documento preferenziale',
            "documentType.options.DDT": 'DDT solo stampa',
            "documentType.options.INVOICE": 'Fattura accompagnatoria',
            "idPaymentCondition": 'Condizione di pagamento',
            "idVatCondition": 'Condizione IVA',
            "idLanguages": 'Lingua',
            "italiaEstero": 'Italia - Estero',
            "certificatoOrigine": 'Certificato d\'origine',
            "codiciDoganaliInFatt": 'Codici doganali in fattura',
            "address": 'Indirizzo di consegna',
            "idSpedizione": 'Tariffe di spedizione',
            "costSpedizione": 'Imponibile spedizione',
            "costImballo": 'Imponibile imballo',
            "costIncasso": 'Imponibile incasso Ri.Ba',
            "totalSpedizione": 'Totale spedizione IVA inclusa',
            "totalImballo": 'Totale imballo IVA inclusa',
            "totalIncasso": 'Totale imponibile incasso Ri.Ba',
            "totalIncassoIva": 'Totale incasso Ri.Ba IVA inclusa',
            "totalImponibile": 'Totale imponibile ordine',
            "totalIva": 'Totale IVA ordine',
            "totalPrice": 'Totale ordine',
            "provvigioneAgente": 'Provvigione agente',
            "provvigionePrescrittore": 'Provvigione prescrittore',
            "idListino": 'Listino di riferimento',
            "idWarehouseOutlet": 'Magazzino',
            "dateSendDocument": 'Data invio documento',
            "idCustomerOffer": 'Preventivo cliente',
            "orderType": 'Tipo ordine',
            "orderType.options.0": 'Standard',
            "orderType.options.1": 'Expo',
            "orderType.options.2": 'Sostituzione',
            "orderType.options.3": 'Conto Visione',
            "orderType.options.4": 'Conto Vendita',
            "orderType.options.5": 'Conto Fiera',
            "fileDocument": 'Documento allegato',
            "numberDocument": 'Numero documento '
        },
        "customer_order_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Codice articolo',
            "name": 'Descrizione articolo',
            "measureUnit": 'Unità di misura',
            "quantity": 'Quantità',
            "fulfilledQuantity": 'Quantità evasa',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "discount4": 'Sconto 4 [%]',
            "discount5": 'Sconto expo [%]',
            "price": 'Prezzo unitario [€]',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_PARTIALLY_COMPLETED": 'Parzialmente evasa',
            "status.options.20_COMPLETED": 'Evaso',
            "internalNotes": 'Note interne',
            "percentualeAgente": 'Percentuale agente',
            "percentualePrescrittore": 'Percentuale prescrittore',
            "packages": 'Colli',
            "packaging": 'Cassa di legno',
            "deliveryTime": 'Settimane di consegna',
            "deliveryDate": 'Data prevista pronto merce',
            "volume": 'Volume imballo (mc)',
            "length": 'Lunghezza imballo (cm)',
            "height": 'Altezza imballo (cm)',
            "depth": 'Profondità imballo (cm)',
            "grossWeight": 'Peso lordo (kg)',
            "netWeight": 'Peso netto (kg)',
            "customsCode": 'Codice doganale',
            "idVatCondition": 'Condizione IVA',
            "totalRow": 'Totale imponibile riga',
            "totalIva": 'Totale IVA riga',
            "total": 'Totale riga',
            "idCustomerOrder": 'Ordine cliente',
            "idShippingPlan": 'ID Piano di carico',
            "pdc": 'Area PDC',
            "bindella": 'Bindella',
            "outOfSize": 'Fuori misura'
        },
        "customer_sales_agent": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSalesAgent": 'Agente',
            "idCustomer": 'Cliente'
        },
        "customer_transport_document": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine cliente',
            "idShippingPlan": 'Piano di carico',
            "rows": 'Articoli',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_INVOICE": 'Fattura creata',
            "status.options.20_DDT": 'DDT creato',
            "packagesQuantity": 'Numero colli',
            "weight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "total": 'Totale',
            "forwarder": 'Spedizioniere'
        },
        "customer_transport_document_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrderRow": 'Riga',
            "code": 'Codice articolo',
            "description": 'Descrizione articolo',
            "quantity": 'Quantità',
            "price": 'Totale',
            "notes": 'Note',
            "idCustomerTransportDocument": 'Documento trasporto',
            "fulfilledQuantity": 'Quantità evasa'
        },
        "ddt_supplier_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplierTransportDocument": 'DDT fornitore',
            "idItemModel": 'Articolo',
            "quantity": 'Quantità'
        },
        "designer": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "percentage": 'Provvigione [%]',
            "idCountry": 'Nazione',
            "address": 'Indirizzo',
            "email": 'Email',
            "phone": 'Telefono',
            "mobile": 'Cellulare',
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "notes": 'Note',
            "language": 'Lingua',
            "language.options.0_ITA": 'Italiano',
            "language.options.1_ENG": 'Inglese',
            "language.options.2_DE": 'Tedesco',
            "language.options.3_SPA": 'Spagnolo',
            "abi": 'ABI',
            "cab": 'CAB',
            "idSupplier": 'Fornitore'
        },
        "formulario": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione',
            "type": 'Tipo',
            "type.options.0_ORDER": 'Preventivo / Ordine',
            "type.options.10_INVOICE": 'DDT / Fattura',
            "type.options.20_COMMERCIAL": 'Interne',
            "type.options.30_DELIVERY": 'Trasporto',
            "idLanguages": 'Lingua'
        },
        "forwarder": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "isDefault": 'Default',
            "notes": 'Note'
        },
        "glossario": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "tag": 'Tag',
            "name": 'Descrizione',
            "notes": 'Note'
        },
        "gyt_order_list_request": {
            "id": 'id',
            "date": 'Data inizio elaborazione',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "finishDate": 'Data fine elaborazione',
            "filters": 'Righe selezionate',
            "filtersSearch": 'Filtri di ricerca',
            "author": 'Utente'
        },
        "gyv_all_supplier_item": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "supplierName": 'Nome fornitore',
            "itemCode": 'Codice articolo',
            "itemName": 'Descrizione articolo',
            "price": 'Prezzo [€]',
            "minQuantity": 'Quantità minima',
            "maxQuantity": 'Quantità massima',
            "active": 'Attivo',
            "leadtime": 'Giorni leadtime',
            "idItemModel": 'Articolo'
        },
        "gyv_close_customer_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "id_order": 'ID ordine',
            "id_item": 'ID articolo',
            "item_name": 'Descrizione articolo',
            "item_code": 'Codice articolo',
            "id_customer": 'ID cliente',
            "purchase_group": 'Gruppo di acquisto',
            "sales_group": 'Gruppo di vendita',
            "customer_name": 'Nome cliente',
            "quantity": 'Quantità',
            "status": 'Stato',
            "status.options.0_PENDING": 'In corso',
            "status.options.10_PARTIALLY_COMPLETED": 'Parziale',
            "status.options.20_COMPLETED": 'Completata',
            "status.options.30_CANCELED": 'Annullata',
            "fulfilledQuantity": 'Quantità evasa',
            "deliveryDate": 'Data di consegna',
            "country": 'ID Nazione',
            "country_name": 'Nazione',
            "city": 'Città',
            "address": 'Indirizzo',
            "riferimento": 'Riferimento ordine',
            "riferimento_customer": 'Riferimento cliente',
            "agent": 'Agente',
            "incoterms": 'Incoterms',
            "payment_condition_group": 'Gruppo di pagamento',
            "id_payment_condition_group": 'ID Gruppo di pagamento',
            "dateOrder": 'Data ordine',
            "bindella": 'Bindella',
            "brand": 'Brand',
            "area_geografica": 'Geografia (Statistiche)',
            "isBlocked": 'Bloccato',
            "packages": 'Colli',
            "grossWeight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "total_price": 'Prezzo totale',
            "total_order": 'Totale ordine',
            "no_mrp": 'No MRP',
            "id_catalog": 'ID Brand',
            "id_family": 'ID Raggruppamento',
            "picking": 'Assieme',
            "notes": 'Note ordine',
            "rowNotes": 'Note riga',
            "idShippingPlan": 'ID Piano di carico',
            "shipping_plan": 'Piano di carico',
            "pdc": 'Area PDC',
            "type_order": 'Tipo ordine',
            "country_name_delivery": 'Nazione consegna',
            "itemModelType": 'Tipologia articolo',
            "numberDocument": 'Numero documento'
        },
        "gyv_customer_transport_document": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine cliente',
            "idShippingPlan": 'Piano di carico',
            "rows": 'Articoli',
            "documentType": 'Tipo documento preferenziale',
            "documentType.options.": 'null',
            "documentType.options.DDT": 'DDT',
            "documentType.options.INVOICE": 'Fattura accompagnatoria',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_INVOICE": 'Fattura creata',
            "status.options.20_DDT": 'DDT creato',
            "internalCode": 'Riferimento ordine',
            "packagesQuantity": 'Numero colli',
            "weight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "agent": 'Agente',
            "customer": 'Cliente',
            "address": 'Sede',
            "total": 'Totale',
            "unloadDDT": 'DDT solo cartaceo',
            "aggregateInvoices": 'Aggrega documenti'
        },
        "gyv_customer_transport_document_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrderRow": 'Riga',
            "code": 'Codice articolo',
            "description": 'Descrizione articolo',
            "quantity": 'Quantità',
            "total": 'Totale',
            "notes": 'Note',
            "fulfilledQuantity": 'Quantità evasa',
            "idCustomerTransportDocument": 'Documento trasporto'
        },
        "gyv_item_model_cor": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "code": 'Codice',
            "name": 'Nome',
            "nameEng": 'Nome (ENG)',
            "nameFra": 'Nome (FRA)',
            "nameSpa": 'Nome (SPA)',
            "nameDeu": 'Nome (DEU)',
            "nameFamily": 'Nome raggruppamento',
            "nameBrand": 'Nome brand',
            "idMeasureUnit": 'Unità di misura',
            "type": 'Tipologia',
            "type.options.0_MATERIA_PRIMA": 'Materia prima',
            "type.options.10_SEMILAVORATI": 'Semilavorati',
            "type.options.20_PRODOTTI_FINITI": 'Prodotto finito',
            "type.options.30_PRODOTTI_VENDITA": 'Prodotto di vendita',
            "type.options.40_ALTRO": 'Altro',
            "type.options.50_IMBALLO": 'Imballo',
            "type.options.60_CASSA_DI_LEGNO": 'Cassa di legno',
            "price": 'Prezzo 01 [€/unità]',
            "price1": 'Prezzo 02 [€/unità]',
            "price2": 'Prezzo 03 [€/unità]',
            "price3": 'Prezzo 04 [€/unità]',
            "price4": 'Prezzo 05 [€/unità]',
            "price5": 'Prezzo 06 [€/unità]',
            "price6": 'Prezzo 07 [€/unità]',
            "deliveryTime": 'Settimane di consegna',
            "netWeight": 'Peso netto (kg)',
            "grossWeight": 'Peso lordo (kg)',
            "volume": 'Volume imballo (mc)',
            "length": 'Lunghezza imballo (cm)',
            "height": 'Altezza imballo (cm)',
            "depth": 'Profondità imballo (cm)',
            "packages": 'Colli',
            "quantityPackages": 'Quantità per collo',
            "customsCode": 'Codice doganale',
            "catalogs": 'Cataloghi',
            "idVatCondition": 'Condizione IVA',
            "picking": 'Assieme',
            "provvigioneAgente": 'Provvigione Agente',
            "provvigionePrescrittore": 'Provvigione Prescrittore'
        },
        "gyv_mpm": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "item_code": 'Codice articolo',
            "item_name": 'Descrizione articolo',
            "item_family": 'Raggruppamento',
            "children": 'Materie prime',
            "phasePrice": 'Costo lavorazione',
            "phaseLeadtime": 'Giorni lavorazione',
            "phaseNotes": 'Note lavorazione',
            "isDefault": 'Default',
            "item_id": 'ID articolo'
        },
        "gyv_mrp_order_list": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Id articolo',
            "item_model_code": 'Codice articolo',
            "item_model_name": 'Descrizione articolo',
            "brand": 'Brand',
            "item_model_family": 'Raggruppamento',
            "requested_quantity": 'Quantità necessaria',
            "supplier_id": 'Id fornitore',
            "supplier_name": 'Fornitore',
            "supplier_default": 'Fornitore default',
            "supplier_price": 'Prezzo fornitore default',
            "supplier_range_price": 'Prezzo fornitore per qtà',
            "supplier_leadtime": 'Leadtime fornitore',
            "minStockQuantity": 'Scorta minima',
            "stockQuantity": 'Giacenza totale',
            "stockQuantitySuppliers": 'Giacenza fornitori',
            "stockQuantityInternal": 'Giacenza interna',
            "orderedQuantity": 'Ordinato',
            "customerPendingQuantity": 'Impegnato (clienti)',
            "availableQuantity": 'Disponibilità immediata',
            "measureUnit": 'Unità di misura',
            "futureAvailability": 'Disponibilità futura',
            "type": 'Tipologia',
            "type.options.0_MATERIA_PRIMA": 'Materia prima',
            "type.options.10_SEMILAVORATI": 'Semilavorati',
            "type.options.20_PRODOTTI_FINITI": 'Prodotto finito',
            "type.options.30_PRODOTTI_VENDITA": 'Prodotto di vendita',
            "type.options.40_ALTRO": 'Altro',
            "type.options.50_IMBALLO": 'Imballo',
            "type.options.60_CASSA_DI_LEGNO": 'Cassa di legno',
            "averagePerWeek": 'Media settimanale',
            "supplier_default_id": 'ID Fornitore default',
            "coverage": 'Copertura',
            "hasOutOfSize": 'Fuori misura',
            "outOfSizeQuantity": 'Quantità fuori misura',
            "sourceRows": 'Righe sorgente'
        },
        "gyv_open_customer_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "id_order": 'ID ordine',
            "id_item": 'ID articolo',
            "item_name": 'Descrizione articolo',
            "item_code": 'Codice articolo',
            "id_customer": 'ID cliente',
            "purchase_group": 'Gruppo di acquisto',
            "sales_group": 'Gruppo di vendita',
            "customer_name": 'Nome cliente',
            "quantity": 'Quantità',
            "status": 'Stato',
            "status.options.0_PENDING": 'In corso',
            "status.options.10_PARTIALLY_COMPLETED": 'Parziale',
            "status.options.20_COMPLETED": 'Completata',
            "status.options.30_CANCELED": 'Annullata',
            "deliveryDate": 'Data di consegna',
            "stockQuantity": 'Giacenza totale',
            "stockQuantityInternal": 'Giacenza interna',
            "previousQta": 'Impegnati precedenti',
            "country": 'ID Nazione anagrafica',
            "country_name": 'Nazione anagrafica',
            "country_name_delivery": 'Nazione consegna',
            "riferimento": 'N. ordine',
            "riferimento_customer": 'Riferimento cliente',
            "badge": 'Disponibile',
            "agent": 'Agente',
            "incoterms": 'Incoterms',
            "payment_condition_group": 'Gruppo di pagamento',
            "id_payment_condition_group": 'ID Gruppo di pagamento',
            "dateOrder": 'Data ordine',
            "bindella": 'Bindella',
            "area_geografica": 'Geografia (Statistiche)',
            "packages": 'Colli',
            "grossWeight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "total_price": 'Prezzo totale',
            "total_order": 'Totale ordine',
            "id_catalog": 'ID Brand',
            "id_family": 'ID Raggruppamento',
            "picking": 'Assieme',
            "notes": 'Note ordine',
            "rowNotes": 'Note riga',
            "pdc": 'Area PDC',
            "idWarehouse": 'ID Magazzino',
            "warehouse": 'Magazzino',
            "ordine_disponibile": 'Ordine disponibile',
            "type_order": 'Tipo ordine',
            "itemModelType": 'Tipologia articolo'
        },
        "gyv_pdc": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "id_order": 'ID ordine',
            "id_item": 'ID articolo',
            "item_name": 'Descrizione articolo',
            "item_code": 'Codice articolo',
            "id_customer": 'ID cliente',
            "sales_group": 'Gruppo di vendita',
            "customer_name": 'Nome cliente',
            "quantity": 'Quantità',
            "deliveryDate": 'Data di consegna',
            "stockQuantity": 'Giacenza totale',
            "stockQuantityInternal": 'Giacenza interna',
            "previousQta": 'Impegnati precedenti',
            "country": 'ID Nazione anagrafica',
            "country_name_delivery": 'Nazione consegna',
            "country_name": 'Nazione anagrafica',
            "riferimento": 'N. ordine',
            "badge": 'Disponibile',
            "agent": 'Agente',
            "incoterms": 'Incoterms',
            "payment_condition_group": 'Gruppo di pagamento',
            "id_payment_condition_group": 'ID Gruppo di pagamento',
            "dateOrder": 'Data ordine',
            "bindella": 'Bindella',
            "area_geografica": 'Geografia (Statistiche)',
            "packages": 'Colli',
            "grossWeight": 'Peso',
            "volume": 'Volume imballo (mc)',
            "total_price": 'Prezzo totale',
            "total_order": 'Totale ordine',
            "id_catalog": 'ID Brand',
            "id_family": 'ID Raggruppamento',
            "picking": 'Assieme',
            "notes": 'Note ordine',
            "rowNotes": 'Note riga',
            "shipping_plan_name": 'Piano di carico',
            "idWarehouse": 'Magazzino',
            "idShippingPlan": 'ID Piano di carico',
            "itemModelType": 'Tipologia articolo'
        },
        "gyv_stocks": {
            "id": 'id',
            "code": 'Codice articolo',
            "name": 'Descrizione articolo',
            "minStockQuantity": 'Scorta minima',
            "stockQuantity": 'Giacenza totale',
            "stockQuantitySuppliers": 'Giacenza fornitori',
            "stockQuantityInternal": 'Giacenza interna',
            "stockQuantityMrp": 'Giacenza MRP',
            "orderedQuantity": 'Ordinato',
            "customerPendingQuantity": 'Impegnato (clienti)',
            "productionPendingQuantity": 'Impegnato (mrp)',
            "availableQuantity": 'Disponibilità immediata',
            "futureAvailability": 'Disponibilità futura',
            "idWarehouse": 'Magazzino',
            "sottoscorta": 'Sottoscorta',
            "sottoscorta.options.0": 'NO',
            "sottoscorta.options.1": 'SI',
            "qta_sottoscorta": 'Quantità sottoscorta',
            "item_model_family": 'Gruppo',
            "ean": 'Ean',
            "averagePerWeek": 'Media settimanale',
            "coverage": 'Copertura'
        },
        "gyv_supplier_order_rows_open": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "typeOrder": 'Tipo ordine',
            "typeOrder.options.0_CONTO_LAVORO": 'Conto lavoro',
            "typeOrder.options.5_MATERIA_PRIMA": 'Materia prima',
            "typeOrder.options.10_PRODUZIONE_INTERNA": 'Produzione interna',
            "typeOrder.options.15_RIPRISTINO": 'Ripristino',
            "orderDate": 'Data ordine',
            "internalCode": 'Numero ordine',
            "externalCode": 'Riferimento interno',
            "supplier_name": 'Fornitore',
            "idSupplierOrder": 'ID Ordine fornitore',
            "idItemModel": 'ID Articolo',
            "idItemModelSupplier": 'ID Articolo fornitore',
            "name": 'Descrizione articolo',
            "measureUnit": 'Unità di misura',
            "quantity": 'Quantità',
            "receivedQuantity": 'Quantità ricevuta',
            "price": 'Prezzo',
            "idVatCondition": 'Condizione IVA',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "packages": 'Colli',
            "grossWeight": 'Peso lordo (kg)',
            "leadtime": 'Settimane di consegna',
            "expectedDate": 'Data prevista',
            "status": 'Stato',
            "status.options.0_PENDING": 'In attesa',
            "status.options.10_PARTIALLY_COMPLETED": 'Parziale',
            "status.options.20_COMPLETED": 'Completata',
            "status.options.30_CANCELED": 'Annullata',
            "notes": 'Note',
            "internalNotes": 'Note interne',
            "totalRow": 'Totale riga',
            "totalIva": 'Totale IVA',
            "total": 'Totale',
            "idLocation": 'Locazione'
        },
        "incoterms": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note',
            "internalDelivery": 'Spedizione a carico nostro'
        },
        "intestazioni": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "keyField": 'Chiave (non modificare)',
            "file": 'File',
            "notes": 'Note'
        },
        "item_model": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "code": 'Codice',
            "name": 'Nome',
            "nameEng": 'Nome (ENG)',
            "nameFra": 'Nome (FRA)',
            "nameSpa": 'Nome (ESP)',
            "nameDeu": 'Nome (DEU)',
            "ean": 'Codice commerciale',
            "type": 'Tipologia',
            "type.options.0_MATERIA_PRIMA": 'Materia prima',
            "type.options.10_SEMILAVORATI": 'Semilavorati',
            "type.options.20_PRODOTTI_FINITI": 'Prodotto finito',
            "type.options.30_PRODOTTI_VENDITA": 'Prodotto di vendita',
            "type.options.40_ALTRO": 'Altro',
            "type.options.50_IMBALLO": 'Imballo',
            "type.options.60_CASSA_DI_LEGNO": 'Cassa di legno',
            "idItemModelFamily": 'Raggruppamento',
            "idMeasureUnit": 'Unità di misura',
            "idAttributes": 'Attributo',
            "idAttributes2": 'Attributo 2',
            "price": 'Prezzo 01 [€/unità]',
            "price1": 'Prezzo 02 [€/unità]',
            "price2": 'Prezzo 03 [€/unità]',
            "price3": 'Prezzo 04 [€/unità]',
            "price4": 'Prezzo 05 [€/unità]',
            "price5": 'Prezzo 06 [€/unità]',
            "price6": 'Prezzo 07 [€/unità]',
            "minStockQuantity": 'Scorta minima',
            "suppliers": 'Listino Fornitori',
            "files": 'Allegati',
            "notes": 'Note',
            "idWarehouse": 'Magazzino default',
            "volume": 'Volume imballo (mc)',
            "grossWeight": 'Peso lordo (kg)',
            "netWeight": 'Peso netto (kg)',
            "length": 'Lunghezza imballo (cm)',
            "height": 'Altezza imballo (cm)',
            "depth": 'Profondità imballo (cm)',
            "lengthItem": 'Lunghezza articolo (mm)',
            "heightItem": 'Altezza articolo (mm)',
            "depthItem": 'Profondità articolo (mm)',
            "deliveryTime": 'Settimane di consegna',
            "coverage": 'Copertura',
            "idDesigner": 'Designer',
            "catalogs": 'Cataloghi',
            "customsCode": 'Codice doganale',
            "packages": 'Colli',
            "no_mrp": 'Escludi da MRP',
            "codiceVecchioGestionale": 'Codice vecchio gestionale',
            "idSupplierDefault": 'Fornitore di default',
            "picking": 'Assieme',
            "idVatCondition": 'Condizione IVA',
            "quantityPackages": 'Quantità per collo',
            "provvigioneAgente": 'Provvigione Agente',
            "provvigionePrescrittore": 'Provvigione Prescrittore',
            "photoGallery": 'Galleria foto',
            "checkMinStock": 'Calcola scorta minima',
            "averagePerWeek": 'Media settimanale',
            "quantity": 'Quantità'
        },
        "item_model_catalog": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "idCatalog": 'Catalogo'
        },
        "item_model_family": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione'
        },
        "item_model_files": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note',
            "file": 'File',
            "idItemModel": 'Articolo'
        },
        "item_model_movement": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "quantity": 'Quantità',
            "type": 'Tipologia',
            "notes": 'Note',
            "type.options.LOAD": 'Carico',
            "type.options.UNLOAD": 'Scarico',
            "idMovementScope": 'Causale movimentazione',
            "idWarehouse": 'Magazzino',
            "numberDocument": 'Riferimento ordine',
            "dateDocument": 'Data documento',
            "company": 'Azienda',
            "numberExternalDocument": 'Numero DDT fornitore',
            "dateExternalDocument": 'Data DDT fornitore'
        },
        "item_model_photo_gallery": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "name": 'Nome',
            "file": 'File'
        },
        "item_model_quantity": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Codice articolo',
            "idWarehouse": 'Magazzino',
            "quantity": 'Quantità'
        },
        "item_model_suppliers": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplier": 'Fornitore',
            "supplierCode": 'Codice fornitore',
            "price": 'Prezzo [€]',
            "minQuantity": 'Quantità minima',
            "maxQuantity": 'Quantità massima',
            "active": 'Attivo',
            "notes": 'Note',
            "leadtime": 'Giorni leadtime',
            "idItemModel": 'Articolo'
        },
        "languages": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note',
            "codiceGestionaleEsterno": 'Codice gestionale esterno'
        },
        "listino": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "price": 'Prezzo',
            "price.options.price": 'Campo Prezzo 1',
            "price.options.price1": 'Campo Prezzo 2',
            "price.options.price2": 'Campo Prezzo 3',
            "price.options.price3": 'Campo Prezzo 4',
            "price.options.price4": 'Campo Prezzo 5',
            "price.options.price5": 'Campo Prezzo 6',
            "price.options.price6": 'Campo Prezzo 7'
        },
        "log": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItem": 'Id elemento',
            "idUser": 'Utente',
            "entity": 'Entità',
            "operation": 'Operazione',
            "operation.options.0_DELETE": 'Elimina',
            "operation.options.1_EDIT": 'Modifica',
            "operation.options.2_ADD": 'Aggiungi',
            "operation.options.3_LOGIN": 'Login',
            "operation.options.4_LOGOUT": 'Logout',
            "notes": 'Note'
        },
        "manufacturing_process_model": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "idSupplier": 'ID Fornitore',
            "itemName": 'Descrizione articolo',
            "notes": 'Note',
            "children": 'Elenco figli',
            "phasePrice": 'Costo lavorazione',
            "phaseLeadtime": 'Giorni lavorazione',
            "phaseNotes": 'Note lavorazione',
            "isDefault": 'Default',
            "nameSupplier": 'Fornitore',
            "minQuantity": 'Quantità minima',
            "maxQuantity": 'Quantità massima'
        },
        "measure_unit": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "symbol": 'Simbolo'
        },
        "movement_scope": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome causale',
            "idWarehouseStart": 'Magazzino di partenza',
            "defaultInvoice": 'Default fattura cliente',
            "defaultDdt": 'Default DDT cliente',
            "defaultSupplierMP": 'Default Materia prima',
            "defaultSupplierCL": 'Default Conto lavoro',
            "defaultSupplierInternal": 'Default Produzione interna',
            "defaultSupplierDdt": 'Default DDT fornitore',
            "defaultUnloadChildren": 'Default Scarico figli fornitore',
            "notes": 'Note'
        },
        "mp_children": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "itemName": 'Descrizione articolo',
            "itemUdm": 'Unità di misura',
            "quantity": 'Quantità',
            "position": 'Posizione',
            "type": 'Tipologia',
            "type.options.0_MATERIA_PRIMA": 'Materia prima',
            "type.options.10_SEMILAVORATI": 'Semilavorati',
            "type.options.20_PRODOTTI_FINITI": 'Prodotto finito',
            "type.options.30_PRODOTTI_VENDITA": 'Prodotto di vendita',
            "type.options.40_ALTRO": 'Altro',
            "type.options.50_IMBALLO": 'Imballo',
            "type.options.60_CASSA_DI_LEGNO": 'Cassa di legno',
            "idMP": 'Distinta base'
        },
        "payment_condition": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "nameEng": 'Nome (ENG)',
            "nameDeu": 'Nome (DEU)',
            "nameFra": 'Nome (FRA)',
            "nameSpa": 'Nome (SPA)',
            "description": 'Descrizione',
            "numberPayments": 'Numero rate',
            "numberInstallments": 'Numero incassi',
            "costInstallment": 'Costo incasso',
            "notes": 'Note',
            "idPaymentConditionGroup": 'Gruppo condizioni di pagamento',
            "codiceGestionaleEsterno": 'Codice gestionale esterno',
            "unloadDDT": 'DDT solo cartaceo'
        },
        "payment_condition_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note',
            "riba": 'Ri.Ba.'
        },
        "person_role": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome'
        },
        "prescrittore": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione sociale',
            "percentage": 'Provvigione [%]',
            "notes": 'Note interne [Prescrittori]',
            "enasarco": 'Enasarco'
        },
        "resource": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUser": 'Utente',
            "entity": 'Entità',
            "filename": 'Nome file',
            "hash": 'Hash',
            "extension": 'Estensione'
        },
        "sales_agent": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione sociale',
            "ccOffer": 'CC Preventivo',
            "ccOrder": 'CC Ordine',
            "ccInvoice": 'CC Fattura',
            "percentage": 'Provvigione [%]',
            "notes": 'Note interne [Agenti]',
            "cataloghi": 'Cataloghi',
            "idCustomer": 'Cliente',
            "idCapoArea": 'Capo area',
            "enasarco": 'Enasarco'
        },
        "sales_agent_cataloghi": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSalesAgent": 'Agente',
            "idCatalog": 'Catalogo'
        },
        "sales_agent_contacts": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSalesAgent": 'Agente',
            "name": 'Nome',
            "surname": 'Cognome',
            "idRole": 'Ruolo',
            "roleDescription": 'Descrizione ruolo',
            "sendOrder": 'CC ordini/preventivi',
            "sendInvoice": 'CC fatture',
            "sendDdt": 'CC ddt',
            "mobile": 'Cellulare',
            "email": 'Email',
            "notes": 'Note'
        },
        "shipping_plan": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "notes": 'Note',
            "name": 'Nome',
            "shippingDate": 'Data spedizione',
            "rows": 'Rif. righe ordine',
            "status": 'Stato',
            "status.options.0_DRAFT": 'Bozza',
            "status.options.10_BOOKED": 'Confermato',
            "status.options.20_SHIPPED": 'Generate fatt. acc.',
            "voyages": 'Viaggi',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "idForwarder": 'Vettore'
        },
        "shipping_plan_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrderRow": 'Riga ordine cliente',
            "idShippingPlan": 'ID Piano di carico',
            "notes": 'Note'
        },
        "shipping_plan_voyages": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idCustomerOrder": 'Ordine cliente',
            "file": 'File allegato',
            "notes": 'Note',
            "idShippingPlan": 'ID Piano di carico'
        },
        "shipping_rates": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione',
            "cost": 'Costo',
            "notes": 'Note',
            "soglia": 'Soglia'
        },
        "statement_intent": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idStatement": 'Id plafond',
            "dateStatement": 'Data plafond',
            "year": 'Anno',
            "protocol": 'Protocollo',
            "dateIssue": 'Data scadenza',
            "number": 'Numero',
            "protocolTel": 'Protocollo Tel',
            "idCustomer": 'Cliente',
            "dataRicevutaTel": 'Data ricevuta',
            "impLimite": 'Importo limite',
            "impUtilizzato": 'Importo utilizzato',
            "progressivoTel": 'Progressivo Tel'
        },
        "supplier": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Ragione Sociale',
            "address": 'Indirizzo',
            "idCountry": 'Nazione',
            "phone": 'Telefono',
            "prod": 'Produzione',
            "idWarehouse": 'Magazzino default',
            "codiceVecchioGestionale": 'Codice vecchio gestionale',
            "orderEmail": 'Email ordini',
            "billingEmail": 'Email DDT',
            "website": 'Sito web',
            "stateVatNumber": 'Stato P.iva',
            "vatNumber": 'P.iva',
            "taxCode": 'Codice fiscale',
            "internalNotes": 'Note visibile interne',
            "notes": 'Note visibile fornitore',
            "showPopup": 'Mostra note interne',
            "idPaymentCondition": 'Condizione di pagamento',
            "idVatCondition": 'Condizione iva',
            "contacts": 'Contatti',
            "offices": 'Indirizzi',
            "language": 'Lingua',
            "language.options.0_ITA": 'Italiano',
            "language.options.1_ENG": 'Inglese',
            "language.options.2_DE": 'Tedesco',
            "language.options.3_SPA": 'Spagnolo',
            "pec": 'PEC',
            "visible": 'Visibile',
            "codiceGestionaleEsterno": 'Codice gestionale esterno'
        },
        "supplier_contacts": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "surname": 'Cognome',
            "idRole": 'Ruolo',
            "phone": 'Telefono',
            "mobile": 'Cellulare',
            "email": 'Email',
            "notes": 'Note',
            "idSupplier": 'Fornitore',
            "roleDescription": 'Descrizione ruolo',
            "sendOrder": 'CC ordini/preventivi',
            "sendInvoice": 'CC fatture',
            "sendDdt": 'CC ddt'
        },
        "supplier_offices": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome sede',
            "phone": 'Telefono',
            "email": 'Email',
            "address": 'Indirizzo',
            "idCountry": 'Nazione',
            "city": 'Città',
            "cap": 'CAP',
            "notes": 'Note',
            "internalNotes": 'Note interne',
            "isDeliveryDefault": 'Default consegna',
            "idSupplier": 'Fornitore'
        },
        "supplier_order": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idSupplier": 'Fornitore',
            "typeOrder": 'Tipo ordine',
            "typeOrder.options.0_CONTO_LAVORO": 'Conto lavoro',
            "typeOrder.options.5_MATERIA_PRIMA": 'Materia prima',
            "typeOrder.options.10_PRODUZIONE_INTERNA": 'Produzione interna',
            "typeOrder.options.15_RIPRISTINO": 'Ripristino',
            "internalCode": 'Numero ordine',
            "externalCode": 'Riferimento interno',
            "orderDate": 'Data ordine',
            "deliveryDate": 'Data consegna prevista',
            "idPaymentCondition": 'Condizione di pagamento',
            "idVatCondition": 'Condizione IVA',
            "file": 'Allegato',
            "notes": 'Note',
            "rows": 'Righe ordine',
            "status": 'Stato',
            "status.options.0_DRAFT": 'Bozza',
            "status.options.2_CONFIRMED": 'In preparazione',
            "status.options.5_READY": 'Da inviare',
            "status.options.15_TO_LOAD": 'Da evadere',
            "status.options.20_FINISH": 'Concluso',
            "idWarehouseStart": 'Magazzino di partenza',
            "idWarehouseFinish": 'Magazzino di arrivo',
            "address": 'Indirizzo',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "totalPrice": 'Totale IVA inclusa',
            "totalIva": 'Totale IVA',
            "totalImponibile": 'Totale imponibile',
            "idForwarder": 'Vettore',
            "scope": 'Causale',
            "weight": 'Peso',
            "itemsAspect": 'Aspetto beni',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "dateSendDocument": 'Data invio documento'
        },
        "supplier_order_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "idItemModelSupplier": 'Listino fornitori',
            "name": 'Descrizione articolo',
            "measureUnit": 'Unità di misura',
            "grossWeight": 'Peso',
            "quantity": 'Quantità',
            "receivedQuantity": 'Quantità ricevuta',
            "price": 'Costo unitario [€]',
            "status": 'Stato',
            "status.options.0_PENDING": 'In corso',
            "status.options.10_LOADED": 'Caricato',
            "status.options.20_COMPLETED": 'Completata',
            "status.options.30_CANCELED": 'Annullata',
            "notes": 'Note',
            "leadtime": 'Giorni leadtime',
            "expectedDate": 'Consegna prevista',
            "discount1": 'Sconto 1 [%]',
            "discount2": 'Sconto 2 [%]',
            "discount3": 'Sconto 3 [%]',
            "idVatCondition": 'Condizione IVA',
            "internalNotes": 'Note interne',
            "packages": 'Colli',
            "totalRow": 'Totale imponibile riga',
            "totalIva": 'Totale IVA riga',
            "total": 'Totale riga',
            "idSupplierOrder": 'Ordine fornitore',
            "idLocation": 'Locazione'
        },
        "supplier_transport_document": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "notes": 'Note',
            "idSupplier": 'Fornitore',
            "rifOrder": 'Riferimento ordine',
            "documentDate": 'Data documento',
            "idTransportDocumentReason": 'Causale',
            "packagesQuantity": 'Numero colli',
            "itemsAspect": 'Aspetto beni',
            "transportBy": 'Trasporto a cura',
            "transportBy.options.0_SENDER": 'Mittente',
            "transportBy.options.1_RECIPIENT": 'Destinatario',
            "transportBy.options.2_CARRIER": 'Vettore',
            "rows": 'Articoli',
            "idSupplierOrder": 'ID ordine',
            "idWarehouseStart": 'Magazzino partenza',
            "idWarehouseFinish": 'Magazzino arrivo',
            "status": 'Stato',
            "status.options.0_PENDING": 'Provvisorio',
            "status.options.5_READY": 'Pronto',
            "status.options.20_UNLOADED": 'Scaricato',
            "weight": 'Peso',
            "internalCode": 'Codice interno',
            "idForwarder": 'Vettore',
            "itemsAspect.options.0_SCATOLE": 'Scatole',
            "itemsAspect.options.5_VISTA": 'A Vista',
            "itemsAspect.options.10_PLURIBOL": 'Pluribol',
            "itemsAspect.options.15_CARTONI": 'Cartoni',
            "dateSendDocument": 'Data invio documento'
        },
        "supplier_transport_document_rows": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idItemModel": 'Articolo',
            "quantity": 'Quantità',
            "notes": 'Note',
            "name": 'Nome',
            "measureUnit": 'Unità di misura',
            "fulfilledQuantity": 'Quantità evasa',
            "status": 'Stato',
            "status.options.0_PENDING": 'Provvisorio',
            "status.options.10_UNLOADED": 'Scaricato',
            "idSupplierTransportDocument": 'DDT fornitore',
            "idLocation": 'Locazione'
        },
        "template": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "language": 'Lingua',
            "language.options.1": 'Italiano',
            "language.options.2": 'Inglese',
            "language.options.3": 'Spagnolo',
            "language.options.4": 'Francese',
            "type": 'Tipo',
            "type.options.1": 'Ordine (Titolo = Proforma)',
            "type.options.2": 'Preventivo (Titolo = Proforma)',
            "type.options.3": 'Ordine (Titolo = Conferma)',
            "type.options.4": 'Preventivo (Titolo = Preventivo)',
            "file": 'File',
            "notes": 'Note',
            "defaultTemplate": 'Predefinito',
            "codiciDoganali": 'Codici doganali',
            "anticipato": 'Anticipato',
            "hideDiscounts": 'Sconti nascosti',
            "objectMail": 'Oggetto mail',
            "bodyMail": 'Corpo mail'
        },
        "template_mail": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "idLanguages": 'Lingua',
            "type": 'Tipo',
            "type.options.1": 'Preventivo fornitore',
            "type.options.2": 'Ordine fornitore',
            "type.options.3": 'DDT fornitore',
            "type.options.4": 'DDT cliente',
            "type.options.5": 'Fattura accompagnatoria',
            "type.options.6": 'Fattura differita',
            "objectMail": 'Oggetto della mail',
            "bodyMail": 'Corpo della mail',
            "notes": 'Note'
        },
        "transport_document_reason": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note'
        },
        "user": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "idUserGroup": 'Gruppo',
            "name": 'Nome',
            "surname": 'Cognome',
            "username": 'Username',
            "email": 'Email',
            "level": 'Livello utente',
            "level.options.0": 'Admin',
            "level.options.1": 'Superuser',
            "level.options.2": 'User',
            "level.options.3": 'Magazziniere',
            "avatar": 'Avatar',
            "password": 'Password',
            "smtp_server": 'Server SMTP',
            "smtp_username": 'Username SMTP',
            "smtp_password": 'Password SMTP',
            "firma_email": 'Firma email',
            "smtp_server_passivo": 'Server SMTP passivo',
            "smtp_username_passivo": 'Username SMTP passivo',
            "smtp_password_passivo": 'Password SMTP passivo',
            "firma_email_passivo": 'Firma email passivo'
        },
        "user_entity_preferences": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "content": 'Json preferenze',
            "label": 'Etichetta',
            "isDefault": 'Default'
        },
        "user_entity_saved_filters": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "author": 'Utente',
            "entity": 'Entità',
            "name": 'Nome',
            "notes": 'Note',
            "content": 'Json filtri'
        },
        "user_group": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome gruppo'
        },
        "vat_condition": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione',
            "percentage": 'Percentuale',
            "notes": 'Note',
            "codiceGestionaleEsterno": 'Codice gestionale esterno'
        },
        "warehouse": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "notes": 'Note',
            "no_mrp": 'No MRP',
            "internal": 'Magazzino interno',
            "defaultSupplier": 'Default Mag. Arrivo/Partenza',
            "checkUnload": 'Controlla giacenze allo scarico'
        },
        "attributes": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "name": 'Nome',
            "description": 'Descrizione',
            "category": 'Categoria',
            "category.options.0_WIN": 'Win-o',
            "category.options.5_LDV": 'LDV',
            "category.options.10_TAVOLO": 'Tavolo',
            "category.options.15_HAKKASAN": 'Hakkasan',
        },
        "company_settings": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "companyName": 'Ragione sociale',
            "vatNumber": 'Partita IVA',
            "taxCode": 'Codice fiscale',
            "address": 'Indirizzo',
            "city": 'Città',
            "province": 'Provincia',
            "cap": 'CAP',
            "country": 'Nazione',
            "phone": 'Telefono',
            "email": 'Email',
            "pec": 'PEC',
            "sdi": 'Codice SDI',
            "arubaUsername": 'Username Aruba',
            "arubaPassword": 'Password Aruba',
            "arubaEnv": 'Ambiente Aruba',
            "arubaEnv.options.test": 'Test',
            "arubaEnv.options.production": 'Produzione'
        },
        "supplier_invoices_received": {
            "id": 'id',
            "date": 'Data',
            "lastUpdate": 'Ultimo aggiornamento',
            "deleted": 'Eliminato',
            "supplierName": 'Fornitore',
            "supplierVat": 'Partita IVA fornitore',
            "invoiceNumber": 'Numero fattura',
            "invoiceDate": 'Data fattura',
            "totalAmount": 'Importo totale',
            "sdiIdSdi": 'Identificativo SDI',
            "sdiFilename": 'Nome file XML',
            "status": 'Stato',
            "status.options.ricevuta": 'Ricevuta',
            "status.options.registrata": 'Registrata',
            "xmlBase64": 'File XML'
        }
    }
};
